<template>
  <div>
    <!-- 共用的头部 -->
    <public-header v-if="headType === 'default'"></public-header>
    <document-header v-if="headType === 'document'"></document-header>
    <router-view/>
    <media-view></media-view>
  </div>
</template>

<script>
  import publicHeader from '@/components/public-header/public-header.vue'
  import DocumentHeader from '@/components/public-header/document-header.vue'
  import mediaView from '@/components/mediaView'
  export default {
    components: {
      publicHeader,
      DocumentHeader,
      mediaView
    },
    data () {
      return {
        headType: ''
      }
    },
    mounted () {
//       this.$router.replace({name:'appApprove'})
    },
    watch: {
      '$route': function (val) {
        if (val.meta && val.meta.headType) {
          this.headType = val.meta.headType
        } else {
          this.headType = 'default'
        }
      }
    }
  }
</script>

<style lang="less">
@import 'assets/less/header.less';
@import "assets/less/style.less";
@import "assets/less/personalCenter.less";
</style>



// WEBPACK FOOTER //
// src/App.vue